import * as yup from 'yup';
import Schema from '@/schema/Schema';
import trI18n from '@/common/utils/trI18n';
import { tr } from '@/common/utils/tr';
import I18n from '@/rI18n';

const UpdateCorporationSchema = Schema.object().shape({
    corporationName: yup
        .string()
        // Message functions: translated at validation time, not frozen at module import
        .required(() => trI18n('COMMSG014'))
        .max(200, () => tr(I18n.get('COMMSG022').replace('{{maxLength}}', '200')))
        .trim(),
    telNumberCorporation: yup
        .string()
        // .required(trI18n('COMMSG014'))
        .trim(),

});

export default UpdateCorporationSchema;
